import { useState, type CSSProperties, type FormEvent } from "react";

export default function Support() {
  const [ok, setOk] = useState<boolean | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setBusy(true);

    const form = new FormData(e.currentTarget);
    const payload = Object.fromEntries(form.entries());

    try {
      const r = await fetch("/api/support", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await r.json().catch(() => ({}));
      setOk(Boolean(data?.ok));
    } catch {
      setOk(false);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={{ maxWidth: 980, margin: "0 auto", padding: "32px 16px 40px" }}>
      <div style={hero}>
        <div style={kicker}>Lumia RAMS · support</div>

        <h1 style={{ fontSize: "clamp(2rem, 5vw, 3rem)", margin: 0 }}>
          Support
        </h1>

        <p style={{ marginTop: 14, opacity: 0.85 }}>
          Questions, bugs, feature ideas — send a message and I’ll take a look.
        </p>
      </div>

      <div style={panel}>
        <form onSubmit={onSubmit} style={{ display: "grid", gap: 14 }}>
          <label>
            <div style={label}>Name</div>
            <input name="name" type="text" placeholder="John Smith" style={inp} />
          </label>

          <label>
            <div style={label}>Email *</div>
            <input name="email" type="email" required placeholder="you@example.com" style={inp} />
          </label>

          <input name="website" style={{ display: "none" }} />

          <label>
            <div style={label}>Message *</div>
            <textarea name="message" required rows={6} placeholder="What’s going on?" style={txt} />
          </label>

          <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}>
            <button type="submit" disabled={busy} style={btn}>
              {busy ? "Sending…" : "Send message"}
            </button>

            {ok === true && <span style={{ color: "#6dffb3" }}>Sent — thanks</span>}
            {ok === false && <span style={{ color: "#ff8a8a" }}>Failed — try again</span>}
          </div>
        </form>
      </div>
    </div>
  );
}

const hero: CSSProperties = {
  padding: "32px 28px",
  borderRadius: 24,
  border: "1px solid rgba(255, 255, 255, 0.08)",
  background:
    "radial-gradient(circle at top left, rgba(109, 94, 252, 0.16), transparent 36%), linear-gradient(180deg, rgba(7, 12, 34, 0.92), rgba(3, 7, 22, 0.98))",
  boxShadow: "0 24px 80px rgba(0, 0, 0, 0.28)",
  marginBottom: 24,
};

const kicker: CSSProperties = {
  fontSize: 13,
  letterSpacing: "0.18em",
  textTransform: "uppercase",
  opacity: 0.7,
  marginBottom: 14,
};

const panel: CSSProperties = {
  maxWidth: 720,
  margin: "0 auto",
  padding: 24,
  borderRadius: 22,
  border: "1px solid rgba(255,255,255,0.08)",
  background: "linear-gradient(180deg, rgba(19, 28, 58, 0.78), rgba(12, 19, 43, 0.86))",
  boxShadow: "0 14px 40px rgba(0,0,0,0.18)",
};

const label: CSSProperties = {
  fontSize: 13,
  opacity: 0.75,
  marginBottom: 6,
};

const inp: CSSProperties = {
  width: "100%",
  padding: "10px 12px",
  borderRadius: 10,
  border: "1px solid rgba(255,255,255,0.12)",
  background: "rgba(255,255,255,0.04)",
  color: "#fff",
};

const txt: CSSProperties = {
  ...inp,
  resize: "vertical",
};

const btn: CSSProperties = {
  padding: "12px 18px",
  borderRadius: 999,
  border: "none",
  background: "#6d5efc",
  color: "#fff",
  fontWeight: 700,
  cursor: "pointer",
  boxShadow: "0 12px 36px rgba(109, 94, 252, 0.34)",
};